function PercentageFilter() {
  return input => {
    if (!input) return null;

    //Changes the answer to string for checking
    //the number of decimal places.
    const numString = input + ''; //eslint-disable-line
    const length = (numString).substring(numString.indexOf('.') + 1).length;

    //if the original decimal places is less then
    //no need to display decimals as we are multiplying by 100
    //else remove two decimals from the result
    let precision = (length < 2 ? 0 : length - 2);

    //if the number never contained a decimal.
    //Don't display decimal.
    if (numString.indexOf('.') === -1) {
      precision = 0;
    }

    const final = `${(input * 100).toFixed(precision)}%`;

    return final;
  };
}

PercentageFilter.$inject = [];

export default PercentageFilter;



// WEBPACK FOOTER //
// ./src/filters/percentage.js